import { colorStopToString, fixTransparentColorStops } from '../color-utils.js';

/**
 * Render a conic gradient
 * @param {CanvasRenderingContext2D} context - Canvas context
 * @param {Object} gradientDef - Gradient definition from parser
 * @param {Object} bounds - Bounding box { x, y, w, h }
 * @returns {CanvasGradient} Canvas gradient object
 */
export function renderConicGradient(context, gradientDef, { x, y, w, h }) {
  // Parse position from orientation
  const position = gradientDef.orientation?.position;
  let centerX = w * 0.5; // Default to center
  let centerY = h * 0.5;

  if (position) {
    // Handle percentage values for x and y
    if (position.x?.type === '%') {
      centerX = w * (parseFloat(position.x.value) / 100);
    }
    if (position.y?.type === '%') {
      centerY = h * (parseFloat(position.y.value) / 100);
    }
  }

  // Parse angle and create gradient
  let angle = 0;
  if (gradientDef.orientation?.value) {
    angle = parseFloat(gradientDef.orientation.value);
    // Normalize angle to be between 0 and 360
    angle = ((angle % 360) + 360) % 360;
    // Convert to radians and adjust 0° to point upward
    angle = (angle * Math.PI) / 180 - Math.PI / 2;
  }

  const gradient = context.createConicGradient(angle, x + centerX, y + centerY);

  // Clone colorStops to avoid mutating the original
  const colorStops = gradientDef.colorStops.map((stop) => ({ ...stop }));

  // Fix transparent color stops to match CSS premultiplied alpha behavior
  fixTransparentColorStops(colorStops);

  // Add color stops
  colorStops.forEach((stop) => {
    let stopPosition = 0;
    if (stop.length?.type === '%') {
      stopPosition = Math.max(0, Math.min(1, parseFloat(stop.length.value) / 100));
    }

    const colorValue = colorStopToString(stop);

    if (colorValue) {
      gradient.addColorStop(stopPosition, colorValue);
    }
  });

  return gradient;
}
